<template>
  <v-card
    id="listener_Produzione2"
    style="text-align: center; padding: 20px; height: 100%"
  >
    <Carrello2
      :back_as_landing_page="back_as_landing_page"
      @click_aggiungi="getWorkOrders()"
      @click_allegati_fase="handleAllegatiFase"
      @click_avanza_contenitore="clickAvanzaContenitore"
      @click_check="handleClickCheck"
      @click_controllo_qualita="handleControlloQualita"
      @click_gestione_pulsanti="showGestionePulsanti()"
      @click_history="handleClickHistory"
      @click_indietro="handleClickIndietro"
      @click_lavoro_squadra="handleClickLavoroSquadra"
      @click_nascondi="nascondiWorkOrder"
      @click_note_commessa="handleNoteCommessa"
      @click_note_fase="handleNoteFase"
      @click_prelievi="clickPrelievi"
      @click_registra_imballi="handleClickRegistraImballi"
      @click_registra_pezzi="clickRegistraPezzi"
      @click_registra_pezzi_alternativi="clickRegistraPezziAlternativi"
      @click_registra_scarti="clickRegistraScarti"
      @click_registra_cont_alternativi="clickRegistraContAlternativi"
      @click_visualizza_allegto_controllo="clickVisualizzaAllegatoControllo"
      @click_visualizza_disegno="clickVisualizzaDisegno"
      @click_scheda_packaging="handleSchedaPackaging"
      @click_scheda_richieste="handleSchedaRichieste"
      @click_start="clickStart"
      @click_stop="clickStop"
      @click_subentro="clickSubentro"
      @config_avvio_multiplo_wo="handleConfigAvvioMultiploWo"
      @id_header_query="handleIdHeaderQuery"
      :handleClickCheck="handleClickCheck"
      :items_carrello="work_orders_in_corso"
      ref="Carrello2"
      style="width: 100%"
    />

    <v-dialog v-model="gestione_pulsanti_visible" width="unset">
      <GestionePulsanti @click_chiudi="gestione_pulsanti_visible = false" />
    </v-dialog>

    <v-dialog v-model="dialog_Richieste" width="unset">
      <Richieste @dialogClose="dialogClose" :hideInterventoButtom="true" />
    </v-dialog>

    <!-- Dialog del consuntivo dei work order -->
    <v-dialog v-model="consuntivo_commesse_visible" width="unset">
      <ConsuntivoWorkOrder
        :avvio_multiplo_enabled="avvio_multiplo_enabled"
        @click_chiudi="consuntivo_commesse_visible = false"
        @inviato_elemento="consuntivo_commesse_visible = false"
        :items_consuntivo="work_orders_totali"
        v-if="consuntivo_commesse_visible == true"
        :visible="consuntivo_commesse_visible"
      />
    </v-dialog>

    <!-- Dialog del consuntivo delle macchine multicommessa -->
    <v-dialog v-model="macchine_multi_visible">
      <ConsuntivoMacchineMulti
        :items_macchine_multi="items_macchine_multi"
        :visible="macchine_multi_visible"
        @click_chiudi="macchine_multi_visible = false"
        @selezionata_macchina="handleSelezionataMacchina"
        v-if="macchine_multi_visible === true"
      />
    </v-dialog>

    <!-- Dialog del consuntivo dei work order per la multicommessa -->
    <v-dialog v-model="consuntivo_wo_multi_visible">
      <ConsuntivoWorkOrderMulti
        :items_wo_multi="items_wo_multi"
        :visible="consuntivo_wo_multi_visible"
        @click_chiudi="consuntivo_wo_multi_visible = false"
        @selezionati_wo="handleSelezionatiWO"
        v-if="consuntivo_wo_multi_visible === true"
      />
    </v-dialog>

    <!-- Dialog di registrazione pezzi -->
    <!--<div
      style="
        background-color: rgba(33, 33, 33, 0.46);
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
      "
      v-if="registra_pezzi_visible"
    >
      <div
        style="height: 90%; left: 1.5%; position: absolute; top: 5%; width: 97%"
      >-->
    <v-dialog v-model="registra_pezzi_visible">
      <RegistraPezzi
        @click_controllo="clickControllo"
        @click_avanti="handleClickAvantiRegistraPezzi"
        @click_indietro="handleClickBackRegPz"
        @click_salva="handleSalvaRegistraPezzi()"
        :flag_em_registrazione="filtroEM === '1' ? filtroEM : ''"
        :id_header_query="id_header_query"
        :visible="registra_pezzi_visible"
        @work_order_completato="handleWorkOrderCompletato()"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di registrazione degli scarti -->
    <v-dialog v-model="registra_scarti_visible">
      <RegistraScarti
        @click_indietro="handleClickBackRegScarti"
        @click_salva="handleSalvaRegistraScarti()"
        :visible="registra_scarti_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di registrazione dei pezzi alternativi -->
    <v-dialog v-model="registra_pezzi_alternativi_visible">
      <RegistraPezziAlt
        @click_indietro="handleClickBackRegPzAlt"
        @click_salva="handleSalvaRegistraPezziAlt()"
        :flag_em_registrazione="filtroEM === '1' ? filtroEM : ''"
        :id_header_query="id_header_query"
        :visible="registra_pezzi_alternativi_visible"
        @work_order_completato="handleWorkOrderAltCompletato()"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog v-model="registra_pezzi_multi_visible">
      <RegistraPezziMulti
        @click_indietro="
          registra_pezzi_multi_visible = !registra_pezzi_multi_visible
        "
        :items_wo_multi_reg_pezzi="items_wo_multi_reg_pezzi"
        :key="key_registra_pezzi_multi"
        @registrati_pezzi="
          getWorkOrdersUtente();
          registra_pezzi_multi_visible = false;
        "
        :visible="registra_pezzi_multi_visible"
      />
    </v-dialog>

    <v-dialog persistent v-model="registra_tempi_visible">
      <RegistraTempi
        @click_salva="handleClickAvantiRegistraTempi()"
        @click_indietro="handleClickIndietroRegistraTempi()"
        :id_header_query="id_header_query"
        ref="registra_tempi"
        :visible="registra_tempi_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog persistent v-model="visualizza_disegno_visible">
      <VisualizzaDisegno
        @click_chiudi="validaDisegno"
        :visible="visualizza_disegno_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog persistent v-model="allegato_controllo_visible" width="unset">
      <GestioneAllegato
        @click_chiudi="allegato_controllo_visible = false"
        :consenti_upload="false"
        controller_allegati="Global"
        controller_caratteristiche_tabella="Manutenzione"
        :id_riferimento="
          work_order_sel != null ? work_order_sel.id_ciclo_fasi : null
        "
        ref="componenteAllegati"
        @snackbarOpen="snackbarOpen"
        tipo_allegato="CONTROLLO"
        :tipo_headers="'minimi'"
      />
    </v-dialog>

    <v-dialog persistent v-model="subentro_visible" width="unset">
      <Subentro
        @click_chiudi="handleCloseSubentro"
        @credenziali_inviate="handleCredInv"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog persistent v-model="avanza_contenitore_visible" width="unset">
      <AvanzaContenitore
        :opzioni_quantita_alternativa="
          opzioni_quantita_alternativa.filter((e) => e.predefinito != 1)
        "
        :pkg_std="pkg_std"
        :workorder="work_order_sel"
        @click_chiudi="handleCloseAvanzaContenitore"
        @registrato_qrcode="handleRegistratoQrCode"
      />
    </v-dialog>

    <!-- Dialog di registrazione dei conetnitori alternativi -->
    <v-dialog
      persistent
      v-model="registra_cont_alternativi_visible"
      width="unset"
    >
      <AvanzaContenitoreAlt
        @click_chiudi="handleClickBackRegContAlt"
        @click_salva="handleSalvaRegistraContAlt()"
        :registrazione_alternativa="1"
        :visible="registra_cont_alternativi_visible"
        :workorder="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog della gestione prelievi -->
    <v-dialog persistent v-model="prelievi_visible">
      <Prelievi
        @aggiorna_work_orders="handleUpdatePrelievi"
        @click_chiudi="handleClickChiudiPrelievi"
        @click_prosegui="
          (prelievi_visible = !prelievi_visible),
            (gestione_lavorazione_visible = !gestione_lavorazione_visible)
        "
        :fase_sel="work_order_sel"
        :visibile="prelievi_visible"
        :modulo_chiamante="'AVANZAMENTO'"
      />
    </v-dialog>

    <!-- Dialog delle note della fase -->
    <v-dialog v-model="dialog_note_fase" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Note Fase</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_note_fase = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-textarea v-model="work_order_sel.note_fase"></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog delle note della fase -->
    <v-dialog v-model="dialog_note_commessa" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Note Commessa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_note_commessa = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pt-5" style="overflow-y: auto">
          <v-textarea
            outlined
            style="border-radius: 0px"
            v-model="work_order_sel.note_commessa"
          ></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di controllo qualità -->
    <v-dialog persistent v-model="controllo_qualita_visible">
      <ControlloQualita
        @click_chiudi="handleCloseContQual"
        @eseguito_controllo="handleRegInv"
        :work_order_sel="work_order_sel"
        :visible="controllo_qualita_visible"
        :key="controllo_qualita_visible === true ? 1 : 0"
      />
    </v-dialog>

    <v-dialog v-model="gestione_allegati_visible">
      <v-card>
        <GestioneAllegato
          @click_chiudi="gestione_allegati_visible = false"
          controller_allegati="Global"
          controller_caratteristiche_tabella="Magazzino"
          :id_riferimento="work_order_sel.id_ciclo_fasi"
          :key="key_allegati"
          :read_only="true"
          ref="componenteAllegati"
          :show_close="true"
          :show_save_button="false"
          @snackbarOpen="snackbarOpen"
          tipo_allegato="CONTROLLO"
          :tipo_headers="'minimi'"
          :toolbar_title="'Documenti Associati'"
        />
      </v-card>
    </v-dialog>

    <div v-show="false">
      <Packaging2
        :data="articolo_per_packaging"
        :quicklabel_allowed="quicklabel_allowed"
        ref="packaging2"
      />
    </div>

    <div
      style="
        background-color: rgba(33, 33, 33, 0.46);
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 2;
      "
      v-if="controllo_dialog_visible"
    >
      <div
        style="height: 90%; left: 5%; position: absolute; top: 5%; width: 90%"
      >
        <Controllo
          @click_indietro="controllo_dialog_visible = false"
          :id_causale_sel="id_causale_sel"
        />
      </div>
    </div>

    <!-- Dialog della history del WO -->
    <v-dialog v-model="history_dialog">
      <HistoryDialogWO
        @click_indietro="history_dialog = false"
        :visible="history_dialog"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog del lavoro squadra -->
    <v-dialog v-model="lavoro_squadra_visible">
      <LavoroSquadra
        @click_chiudi="handleCloseLavoroSquadra"
        @salvato_lavoro="handleSalvatoLavoro"
        :visible="lavoro_squadra_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog della registrazione imballi -->
    <v-dialog v-model="dialog_registrazione_imballi" width="75vw" persistent>
      <StampaEtichetteComponent
        @chiudi="dialog_registrazione_imballi = false"
        @registrazione_avvenuta="handleRegAvvImballi"
        :visible="dialog_registrazione_imballi"
        :workorder="work_order_sel"
      />
    </v-dialog>

    <!-- Componente di QuickCheck -->
    <!-- Dialog del componente dinamico Check -->
    <v-dialog class="ma-0 pa-0" v-model="check_dialog_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeCheck"
            :component="'check'"
            @fine_sessione_check="handleFineSessione"
            :input_args="input_args"
            :key="key_check"
            ref="windowframe_check"
            @loaded="handleCheckLoaded()"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma esecuzione QuickCheck -->
    <v-dialog v-model="conferma_check_visible" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Questionario </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            È stato rilevato un questionario non completato, vuoi terminarlo?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="noConfermaEseguiCheck()" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="confermaEseguiCheck(getrelazioni)" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="caricamento_dati">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import AvanzaContenitore from "@/components/PRODUCTION/ProduzioneInsit/AvanzaContenitore.vue";
import AvanzaContenitoreAlt from "@/components/PRODUCTION/ProduzioneInsit/AvanzaContenitoreAlt.vue";
import Carrello2 from "@/components/PRODUCTION/ProduzioneInsit/Carrello2.vue";
import ConsuntivoMacchineMulti from "@/components/PRODUCTION/ProduzioneInsit/ConsuntivoMacchineMulti.vue";
import ConsuntivoWorkOrder from "@/components/PRODUCTION/ProduzioneInsit/ConsuntivoWorkOrder.vue";
import ConsuntivoWorkOrderMulti from "@/components/PRODUCTION/ProduzioneInsit/ConsuntivoWorkOrderMulti.vue";
import Controllo from "@/views/PRODUCTION/Controllo/Controllo.vue";
import ControlloQualita from "@/components/PRODUCTION/Produzione/ControlloQualita.vue";
import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import GestionePulsanti from "@/components/PRODUCTION/ProduzioneInsit/GestionePulsanti.vue";
import HistoryDialogWO from "@/components/PRODUCTION/ProduzioneInsit/HistoryDialogWO.vue";
import LavoroSquadra from "@/components/PRODUCTION/ProduzioneInsit/LavoroSquadra.vue";
import Packaging2 from "@/views/PRODUCTION/Articolo/ArticoloDrawer/Packaging2.vue";
import Prelievi from "@/components/PRODUCTION/Produzione/Prelievi.vue";
import RegistraPezzi from "@/components/PRODUCTION/ProduzioneInsit/RegistraPezzi.vue";
import RegistraPezziAlt from "@/components/PRODUCTION/ProduzioneInsit/RegistraPezziAlt.vue";
import RegistraPezziMulti from "@/components/PRODUCTION/ProduzioneInsit/RegistraPezziMulti.vue";
import RegistraScarti from "@/components/PRODUCTION/ProduzioneInsit/RegistraScarti.vue";
import RegistraTempi from "@/components/PRODUCTION/ProduzioneInsit/RegistraTempi.vue";
import Richieste from "@/components/QUICKMANUTENZIONE/Richieste/Richiesta";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import StampaEtichetteComponent from "@/components/PRODUCTION/ProduzioneInsit/StampaEtichetteComponent.vue";
import Subentro from "@/components/PRODUCTION/Produzione/Subentro.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import VisualizzaDisegno from "@/components/PRODUCTION/ProduzioneInsit/VisualizzaDisegno.vue";

export default {
  components: {
    AvanzaContenitore,
    AvanzaContenitoreAlt,
    Carrello2,
    ConsuntivoMacchineMulti,
    ConsuntivoWorkOrder,
    ConsuntivoWorkOrderMulti,
    Controllo,
    ControlloQualita,
    GestioneAllegato,
    GestionePulsanti,
    HistoryDialogWO,
    LavoroSquadra,
    Packaging2,
    Prelievi,
    RegistraPezzi,
    RegistraPezziAlt,
    RegistraPezziMulti,
    RegistraScarti,
    RegistraTempi,
    Richieste,
    SnackbarQV,
    StampaEtichetteComponent,
    Subentro,
    VisualizzaDisegno,
    WindowFrame,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    cod_commessa: {
      type: String,
      default: "",
    },
    commessa: {
      type: Object,
      default: () => {},
    },
    filtroEM: {
      type: String,
      default: "",
    },
    open_consuntivi_if_empty: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      articolo_per_packaging: { id_articolo: null },
      caricamento_dati: false,
      getrelazioni: null,
      id_causale_sel: null,
      id_header_query: null,
      input_args: {
        toolbar_visible: false,
        dizionario: new Object(),
        esterno: 1,
      },
      key_allegati: 0,
      key_check: 0,
      key_registra_pezzi_multi: 0,
        landing_page_check: "quiz_detail",
      nascondi_WO: false,
      pkg_std: new Object(),
      quest_app_exec_ok: false,
      quicklabel_allowed: 0,
      sse_src: null,
      work_order_sel: new Object(),

      // Modal
      allegato_controllo_visible: false,
      avanza_contenitore_visible: false,
      avvio_multiplo_enabled: 0,
      check_dialog_visible: false,
      conferma_check_visible: false,
      consuntivo_commesse_visible: false,
      consuntivo_wo_multi_visible: false,
      controllo_dialog_visible: false,
      controllo_qualita_visible: false,
      dialog_note_commessa: false,
      dialog_note_fase: false,
      dialog_registrazione_imballi: false,
      gestione_allegati_visible: false,
      gestione_pulsanti_visible: false,
      history_dialog: false,
      lavoro_squadra_visible: false,
      macchine_multi_visible: false,
      prelievi_visible: false,
      registra_cont_alternativi_visible: false,
      registra_pezzi_visible: false,
      registra_pezzi_alternativi_visible: false,
      registra_pezzi_multi_visible: false,
      registra_scarti_visible: false,
      registra_tempi_visible: false,
      subentro_visible: false,
      subentro_waiting: false,
      visualizza_disegno_visible: false,
      dialog_Richieste: false,

      // Array
      items_wo_multi: [],
      items_wo_multi_reg_pezzi: [],
      items_macchine_multi: [],
      work_orders_in_corso: [],
      work_orders_totali: [],
      opzioni_quantita_alternativa: [],
      stack_check: new Array(),
    };
  },
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          // Popolo la lista delle macchine
          this.getListaMacchine();

          // Popolo l'array dei work order già presi in carico.
          await this.getWorkOrdersUtente();

          /* Se sono non ci sono WO in corso e la prop me
           * lo consente, apro il dialog dei consuntivi per
           * scegliere dei WO da aggiungere al carrello. */
          if (
            this.work_orders_in_corso.length === 0 &&
            this.open_consuntivi_if_empty === true
          ) {
            this.$refs.Carrello2.clickAggiungi();
          }
        }
      },
    },
  },
  methods: {
    dialogClose() {
      this.dialog_Richieste = false;
    },
    aggiungiWorkOrder(messaggio) {
      // Controllo che la commessa non sia già nel carrello.
      let ricorre = false;

      this.work_orders_in_corso.forEach((elem) => {
        if (
          elem.id_commessa_dettaglio ==
          messaggio.detail.work_order_sel.id_commessa_dettaglio
        ) {
          ricorre = true;
        }
      });

      // Stampo errore se la commessa è già nel carrello.
      if (ricorre == true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Work Order già presente nel carrello."
        );
      } else {
        /* Se è tutto ok aggiungo la commessa al carrello e apro
         * la finestra di evasione della commessa.*/
        let WO_da_aggiungere = Object.assign(
          {},
          messaggio.detail.work_order_sel
        );

        this.work_orders_in_corso.push(WO_da_aggiungere);
      }
    },
    async aggiungiWorkOrderAndStart(messaggio) {
      // Controllo che la commessa non sia già nel carrello.
      let ricorre = false;

      messaggio.detail.workorders.forEach((wo) => {
        this.work_orders_in_corso.forEach((elem) => {
          if (elem.id_commessa_dettaglio == wo.id_commessa_dettaglio) {
            ricorre = true;
          }
        });
      });

      /* Stampo errore se il WO è già nel
       * carrello e non faccio nient'altro. */
      if (ricorre == true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Work Order già presente nel carrello."
        );
        return;
      }

      /* Se è tutto ok mando gli start in batteria e alla
       * fine di tutto faccio una get per aggiornare i dati.*/
      const WO_da_aggiungere = Array.from(messaggio.detail.workorders);

      /* Tutti i WO mandano la set ma non fanno la
       * get di aggiornamento, tranne l'ultimo WO. */
      for (let i = 0; i < WO_da_aggiungere.length; i++) {
        if (i < WO_da_aggiungere.length - 1) {
          await this.$refs.Carrello2.switchStartStop(
            WO_da_aggiungere[i],
            "",
            "off"
          );
        } else {
          await this.$refs.Carrello2.switchStartStop(
            WO_da_aggiungere[i],
            "",
            "on"
          );
        }
      }
    },
    async clickAvanzaContenitore(item) {
      this.work_order_sel = Object.assign({}, item);

      /* Prendo i packaging alternativi. Questi packaging saranno filtrati nella
       * prop passata al componente togliendo quello che ha il flag di predefinito. */
      this.opzioni_quantita_alternativa = await this.getArticoloPackaging(
        item.id_articolo
      );

      // Resetto il packaging standard nel caso fosse già stato valorizzato.
      this.pkg_std = new Object();
      this.pkg_std.id_articolo_packaging = null;
      this.pkg_std.qta_contenitore = null;

      /* Cerco un packaging standard e se c'è lo uso
       * per valorizzare l'oggetto appena creato. */
      this.opzioni_quantita_alternativa.forEach((o) => {
        if (o.predefinito == 1) {
          this.pkg_std.id_articolo_packaging = o.id_articolo_packaging;
          this.pkg_std.qta_contenitore = o.qta_contenitore;
        }
      });

      // Mostro il dialog dell'avanzamento dei contenitori.
      this.avanza_contenitore_visible = true;
    },
    clickPrelievi(item) {
      this.work_order_sel = Object.assign({}, item);
      this.prelievi_visible = true;
    },
    clickRegistraPezzi(item) {
      this.registra_pezzi_visible = true;
      this.work_order_sel = Object.assign({}, item);
    },
    clickRegistraScarti(item) {
      this.registra_scarti_visible = true;
      this.work_order_sel = Object.assign({}, item);
    },
    clickRegistraPezziAlternativi(item) {
      this.registra_pezzi_alternativi_visible = true;
      this.work_order_sel = Object.assign({}, item);
    },
    async clickRegistraContAlternativi(item) {
      this.work_order_sel = Object.assign({}, item);
      this.registra_cont_alternativi_visible = true;
    },
    clickStart() {
      this.getWorkOrdersUtente();
    },
    clickStop(commessa, arg_nascondi, arg_dialog) {
      // Ricarico i dati dal BE
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutentegenerale",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? this.commessa.cod_commessa : "",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Svuoto l'array che contiene le commesse in gestione
          this.work_orders_in_corso = [];

          // Popolo l'array che contiene i dati totali
          res.data.workorders.workorder.forEach((elem) => {
            /* Se ce l'ha, formatto la Produzione reale della fase
             * per convenienza di FE. */
            if (elem.pzhreale != null) {
              elem.pzhreale = elem.pzhreale.toFixed(2);
            }

            /* Se ce l'ha, formatto il tempo ciclo della fase
             * per convenienza di FE. */
            if (elem.tempo_ciclo != null) {
              elem.tempo_ciclo = elem.tempo_ciclo.toFixed(2);
            }

            this.work_orders_in_corso.push(elem);
          });

          this.caricamento_dati = false;

          /* Se sto nascondendo il WO, registro che lo sto nascondendo
           * in modo da far scattare il metodo di nascondimento quando
           * i dialog si chiuderanno. */
          if (arg_nascondi === "nascondi") {
            this.nascondi_WO = true;
          }

          /* Se l'evento che ha lanciato il metodo porta l'informazione di
           * aprire il dialog di registrazione, cerco il Work Order che ho
           * selezionato e ne apro la Dichiarazione. */
          if (arg_dialog === "dialog_on") {
            this.work_orders_in_corso.forEach((elem) => {
              if (
                elem.id_commessa_dettaglio == commessa.id_commessa_dettaglio
              ) {
                this.clickRegistraPezzi(elem);
              }
            });
          }
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Non è stato possibile caricare i dati: codice errore ${res.status}.`
          );
        }
      });
    },
    clickSubentro(item) {
      this.work_order_sel = Object.assign({}, item);
      this.registra_pezzi_visible = true;
      this.subentro_waiting = true;
    },
    chiudiScatolaStandard(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_contenitori,
      qta_pezzi
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getWorkOrdersUtente();
          this.$refs.SnackbarQV.print(
            "success",
            `Avanzamento di ${(
              parseFloat(qta_pezzi) * parseInt(qta_contenitori)
            )
              .toFixed(2)
              .replace(
                ".",
                ","
              )} unità dell'articolo ${cod_articolo} eseguito con successo!`
          );
        }
      });
    },
    chiudiScatolaAlternativa(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      id_contenitore,
      qta_contenitori,
      qta_pezzi
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          id_contenitore: id_contenitore,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getWorkOrdersUtente();
          this.$refs.SnackbarQV.print(
            "success",
            `Avanzamento contenitori (quantità ${(
              parseFloat(qta_pezzi) * parseInt(qta_contenitori)
            )
              .toFixed(2)
              .replace(
                ".",
                ","
              )} unità) dell'articolo ${cod_articolo} eseguito con successo!`
          );
        }
      });
    },
    chiudiScatolaLibera(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_contenitori,
      qta_pezzi
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getWorkOrdersUtente();
          this.$refs.SnackbarQV.print(
            "success",
            `Avanzamento contenitori (quantità ${(
              parseFloat(qta_pezzi) * parseInt(qta_contenitori)
            )
              .toFixed(2)
              .replace(
                ".",
                ","
              )} unità) dell'articolo ${cod_articolo} eseguito con successo!`
          );
        }
      });
    },
    chiudi_allegato_controllo() {
      this.allegato_controllo_visible = false;
    },
    clickConsuntivoCommesse() {
      this.consuntivo_commesse_visible = true;
    },
    clickControllo(id) {
      this.controllo_dialog_visible = true;
      // Compongo un messaggio.
      let messaggio = {
        detail: {
          id: id,
        },
        src: null,
      };

      // Inserisco il messaggio in un evento custom.
      let evento = new CustomEvent("nuovo_id", messaggio);

      // Recapito l'evento alla mia destinazione.
      setTimeout(function () {
        document
          .getElementById("listener_visualizzatore")
          .dispatchEvent(evento);
      }, 1000);
    },
    clickVisualizzaAllegatoControllo(item) {
      // Se non ci sono allegati stampo una snackbar di errore.
      if (item.check_allegato == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono allegati per questo Work Order"
        );
      } else {
        // Se invece gli allegati ci sono, faccio la chiamata per averli.
        this.allegato_controllo_visible = true;
        this.work_order_sel = Object.assign({}, item);
      }
    },
    clickVisualizzaDisegno(item) {
      if (item.view_disegno == 0) {
        /* Se il disegno non è ancora stato visualizzato mando
         * una chiamata al BE e apro il dialog. */
        let request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setviewdisegno",
            token: localStorage.getItem("user_token"),
            id_disegno: item.id_disegno,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            this.visualizza_disegno_visible = true;
            this.work_order_sel = Object.assign({}, item);
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Non è stato possibile caricare i dati: codice errore ${res.status}.`
            );
          }
        });
      } else {
        /* Se il disegno è già stato visualizzato apro
         * il dialog semplicementa, senza chiamare il BE. */
        this.visualizza_disegno_visible = true;
        this.work_order_sel = Object.assign({}, item);
      }
    },
    closeCheck() {
      this.check_dialog_visible = false;
      this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        dizionario: JSON.parse(JSON.stringify(this.work_order_sel)),
        landing_page: this.landing_page_check,
      });
    },
    confermaEseguiCheck(arg) {
      // Imposto i dati per lanciare il questionario.
      this.input_args.id_questionario = arg.id_modulo;
      this.input_args.id_relazione = arg.id_relazione;
      this.input_args.id_relazione_log = arg.id_relazione_log;
      this.landing_page_check = "quiz_detail/" + arg.id_modulo;
      this.input_args.esterno = 1;

      this.key_check = this.key_check == 0 ? 1 : 0;

      /* Lancio il questionario e metto a false
       * l'eventuale finestra di dialogo per confermare
       * o negare la volontà dell'utente di rispondere
       * a un questionario opzionale. */
      this.check_dialog_visible = true;
      this.conferma_check_visible = false;
    },
    showGestionePulsanti() {
      this.gestione_pulsanti_visible = true;
    },
    getWorkOrders() {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkorders",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.cod_commessa,
          filtroEM: this.filtroEM,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Svuoto l'array che contiene le commesse in gestione
          this.work_orders_totali = [];

          /* Popolo l'array che contiene i dati totali
           * inserendo solo le fasi con id_stato fase diverso
           * da 1 (ovvero le fasi che non sono chiuse). */
          res.data
            .filter((e) => e.id_stato_fase != 1)
            .forEach((elem) => {
              elem.selezionato = false;
              this.work_orders_totali.push(elem);
            });

          // Apro il dialog delle fasi avviabili.
          this.consuntivo_commesse_visible = true;
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
          );
        }

        // Fermo l'overlay di caricamento.
        this.caricamento_dati = false;
      });
    },
    getListaMacchine() {
      let request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          res.data.macchine.forEach((m) => {
            if (m.multi_commessa == 1) {
              delete m.macchina_img;
              this.items_macchine_multi.push(m);
            }
          });
        }
      });
    },
    getQuickLabelAllowed() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni su QuickLabel, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              ).length > 0
            ) {
              this.quicklabel_allowed = res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getRelazioniModuli(codice_btn) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          codice: codice_btn,
          id_riferimento: this.work_order_sel.id_commessa_dettaglio,
          id_personale: localStorage.id,
          riferimento: "commessa_dettaglio",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.dati.length > 0) {
              let object = {
                id_relazione: res.data.result.dati[0].id_relazione,
                id_modulo: res.data.result.dati[0].id_start,
                exec: res.data.result.dati[0]._exec,
                id_relazione_log: res.data.result.dati[0].id_relazione_log,
              };
              return object;
            } else {
              return {
                exec: "N",
              };
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getWorkOrdersUtente() {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutentegenerale",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? this.commessa.cod_commessa : "",
        },
      };

      return this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Svuoto l'array che contiene le commesse in gestione
          this.work_orders_in_corso = [];

          // Popolo l'array che contiene le fasi in gestione
          res.data.workorders.workorder.forEach((elem) => {
            /* Se ce l'ha, formatto la Produzione reale della fase
             * per convenienza di FE. */
            if (elem.pzhreale != null) {
              elem.pzhreale = elem.pzhreale.toFixed(2);
            }

            /* Se ce l'ha, formatto il tempo ciclo della fase
             * per convenienza di FE. */
            if (elem.tempo_ciclo != null) {
              elem.tempo_ciclo = elem.tempo_ciclo.toFixed(2);
            }

            this.work_orders_in_corso.push(elem);
          });
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
          );
        }

        this.caricamento_dati = false;
      });
    },
    handleAllegatiFase(arg) {
      this.work_order_sel = Object.assign({}, arg);
      this.key_allegati = this.key_allegati === 0 ? 1 : 0;
      this.gestione_allegati_visible = true;
    },
    handleClickBackRegPz() {
      this.registra_pezzi_visible = false;
      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    handleClickBackRegContAlt() {
      this.registra_cont_alternativi_visible = false;
    },
    handleClickBackRegPzAlt() {
      this.registra_pezzi_alternativi_visible = false;
      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    handleClickBackRegScarti() {
      this.registra_scarti_visible = false;
    },
    async handleClickCheck(arg, codice_btn, stack_obj) {
      // Registro il WO cliccato.
      this.work_order_sel = Object.assign({}, arg);

      /* Mi metto da parte l'oggetto che contiene le
       * informazioni sul questionario a cui devo rispondere. */
      const getrelazioni_tmp = await this.getRelazioniModuli(codice_btn);

      /* In base alla risposta del server, decido come regolare
       * il comportamento della logica di QuickCheck. */
      switch (getrelazioni_tmp.exec) {
        case "S":
          /* Se ho appena finito di eseguire un questionario
           * con esito positivo non chiedo più al BE se ci sono
           * questionari da eseguire e vado avanti con la normale
           * logica della funzione. */
          if (this.quest_app_exec_ok === true) {
            this.quest_app_exec_ok = false;
            return "N";
          }

          /* ... Altrimenti evo rispondere al questionario, quindi
           * metto i dati della funzione in uno stack di attesa. */
          stack_obj.obbligatorieta = "S";
          this.stack_check.push(stack_obj);

          this.confermaEseguiCheck(getrelazioni_tmp);
          return "S";
        case "N":
          return "N";
        case "X":
          /* Se getrelazioni è null lo valorizzo con l'oggetto
           * contenente le informazioni del questionario, se invece
           * non lo è vuol dire che sono già passato di qui e che ora
           * sto negando di voler eseguire un questionario opzionale
           * quindi ritornerò N come se non ci fosse alcun questionario
           * da fare. */
          if (this.getrelazioni === null) {
            this.getrelazioni = getrelazioni_tmp;

            /* Potrei rispondere al questionario: apro
             * la finestra di dialogo e mi metto da parte
             * il metodo che dovrebbe essere eseguito. Se
             * l'utente dice che non vuole eseguire il
             * questionario, lancio il metodo che mi sono
             * messo da parte. */
            stack_obj.obbligatorieta = "X";
            this.stack_check.push(stack_obj);
            this.conferma_check_visible = true;

            /* Ritorno S per far fermare la logica della
             * funzione chiamante nel componente figlio. */
            return "S";
          } else {
            this.getrelazioni = null;
            return "N";
          }

        default:
          return "N";
      }
    },
    handleClickChiudiPrelievi(arg_bool) {
      this.prelievi_visible = false;

      if (arg_bool === true) {
        /* Devo controllare se ci sono questionari da eseguire in chiusura
         * del dialog. Per farlo uso la funzione handleClickCheck che è la
         * stessa che viene usata per sapere se ci sono questionari da
         * eseguire al click su qualsiasi bottone del cruscotto di
         * avanzamento. Mi metto da parte il WO attualmente selezionato
         * e lo passo alla funzione. Le passo anche un codice univoco
         * che identifica la chiusura di questo specifico dialog e una
         * funzione vuota e innocua perché una volta finito il
         * questionario non voglio che vanga fatto più nulla di specifico.*/
        const obj_tmp = JSON.parse(JSON.stringify(this.work_order_sel));

        let that = this;

        const stack_obj = {
          funzione: function () {
            that.handleClickChiudiPrelievi(arg_bool);
          },
        };

        this.handleClickCheck(obj_tmp, "CLS_PRELIEVI_AVANZAMENTO", stack_obj);
      }
    },
    handleClickHistory(arg) {
      this.work_order_sel = Object.assign({}, arg);
      this.history_dialog = true;
    },
    async handleClickIndietroRegistraTempi() {
      this.registra_tempi_visible = !this.registra_tempi_visible;

      // Aggiorno i dati della tabella.
      await this.getWorkOrdersUtente();

      /* Se devo eseguire un subentro, apro
       * la relativa finestra di dialogo. */
      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      // Se devo nascondere il WO, lo nascondo.
      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    handleClickLavoroSquadra(arg) {
      this.work_order_sel = Object.assign({}, arg);
      this.lavoro_squadra_visible = true;
    },
    handleClickRegistraImballi(arg) {
      this.work_order_sel = Object.assign({}, arg);
      this.dialog_registrazione_imballi = true;
    },
    handleCloseLavoroSquadra() {
      this.lavoro_squadra_visible = false;
    },
    handleCloseSubentro() {
      this.subentro_visible = false;
    },
    handleConfigAvvioMultiploWo(arg) {
      this.avvio_multiplo_enabled = arg;
    },
    handleCredInv(arg_nominativo) {
      this.subentro_visible = false;
      this.$refs.SnackbarQV.print(
        "success",
        `Subentro di ${arg_nominativo} eseguito con successo.`
      );
      this.getWorkOrdersUtente();
    },
    handleFineSessione(arg) {
      if (arg.punteggio == null) {
        this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
      }

      if (arg.punteggio < 100) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );
      }

      if (arg.punteggio == 100) {
        this.$refs.SnackbarQV.print(
          "success",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );
      }

      this.check_dialog_visible = false;

      if (this.stack_check[0]) {
        if (
          this.stack_check[0].obbligatorieta == "X" ||
          (this.stack_check[0].obbligatorieta == "S" && arg.punteggio == 100)
        ) {
          // Registro di aver appena eseguito un questionario.
          this.quest_app_exec_ok = true;

          // Eseguo la funzione che sta attendendo nello stack.
          this.stack_check[0].funzione();

          // Azzero l'array di stack.
          this.stack_check = new Array();
        }
      }
    },
    handleIdHeaderQuery(arg) {
      this.id_header_query = arg;
    },
    handleNoteCommessa(arg) {
      this.work_order_sel = Object.assign({}, arg);
      /* Controllo che ci siano note commessa da
       * visualizzare, altrimenti non apro nulla. */
      if (
        this.work_order_sel.note_commessa == null ||
        this.work_order_sel.note_commessa == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono note da visualizzare per questa commessa."
        );
        return;
      }

      this.dialog_note_commessa = true;
    },
    handleNoteFase(arg) {
      this.work_order_sel = Object.assign({}, arg);
      /* Controllo che ci siano note commessa da
       * visualizzare, altrimenti non apro nulla. */
      if (
        this.work_order_sel.note_fase == null ||
        this.work_order_sel.note_fase == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono note da visualizzare per questa fase."
        );
        return;
      }
      this.dialog_note_fase = true;
    },
    handleCloseAvanzaContenitore(
      tipo_contenitore,
      id_contenitore,
      workorder,
      qta_contenitori,
      qta_pezzi
    ) {
      this.avanza_contenitore_visible = false;

      /* Se non c'è un tipo di contenitore vuol
       * dire che ho veramente soltanto chiuso. */
      if (tipo_contenitore == null) {
        return;
      }

      // Se invece ho i dati, eseguo la chiamata debita.
      if (tipo_contenitore == "standard") {
        this.chiudiScatolaStandard(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi
        );
      } else if (tipo_contenitore == "alternativa") {
        const contenitore_alternativo = this.opzioni_quantita_alternativa.find(
          (item) => item.id_articolo_packaging == id_contenitore
        );

        this.chiudiScatolaAlternativa(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          contenitore_alternativo.id_articolo_contenitore,
          qta_contenitori,
          qta_pezzi
        );
      } else {
        this.chiudiScatolaLibera(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi
        );
      }
    },
    handleAddMultiRegistrazione() {
      this.macchine_multi_visible = true;
    },
    handleClickAvantiRegistraPezzi() {
      this.registra_pezzi_visible = !this.registra_pezzi_visible;
      this.registra_tempi_visible = true;
    },
    async handleClickAvantiRegistraTempi() {
      this.registra_tempi_visible = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione dei dati avvenuta con successo!"
      );

      // Aggiorno i dati della tabella.
      await this.getWorkOrdersUtente();

      // Se devo far scattare il cruscotto di subentro, lo apro.
      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      // Se devo nascondere il WO, lo nascondo.
      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    handleClickIndietro() {
      this.$emit("click_indietro");
    },
    handleCloseContQual() {
      this.controllo_qualita_visible = false;
    },
    handleControlloQualita(arg) {
      this.work_order_sel = Object.assign({}, arg);
      this.controllo_qualita_visible = true;
    },
    handleRegAvvImballi() {
      this.getWorkOrdersUtente();
    },
    async handleRegInv() {
      this.controllo_qualita_visible = false;
      this.getWorkOrdersUtente();
      this.$refs.SnackbarQV.print("success", "Controllo eseguito!");
    },
    handleRegistratoQrCode() {
      this.avanza_contenitore_visible = false;
      this.getWorkOrdersUtente();
      this.$refs.SnackbarQV.print(
        "success",
        "Avanzamento registrato con successo!"
      );
    },
    handleSalvaRegistraContAlt() {
      this.registra_cont_alternativi_visible = !this
        .registra_cont_alternativi_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();
    },
    handleSalvaRegistraPezzi() {
      this.registra_pezzi_visible = !this.registra_pezzi_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();

      // Apro la finestra di dialogo dei tempi
      this.registra_tempi_visible = true;
    },
    handleSalvaRegistraScarti() {
      this.registra_scarti_visible = !this.registra_scarti_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();
    },
    handleSalvaRegistraPezziAlt() {
      this.registra_pezzi_alternativi_visible = !this
        .registra_pezzi_alternativi_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();
    },
    handleSalvatoLavoro() {
      this.lavoro_squadra_visible = false;
    },
    async handleSchedaPackaging(arg) {
      this.articolo_per_packaging = Object.assign(
        {},
        {
          id_articolo: arg.id_articolo,
        }
      );

      const that = this;
      this.$nextTick(async () => {
        /* Mi faccio dare dal BE le testate dei vari contenitori
         * disponibili per l'articolo in questione. */
        that.caricamento_dati = true;
        const fetch = await that.$refs.packaging2.fetchPackaging();

        // Se effettivamente sono stati trovati dei contenitori...
        if (
          fetch === true &&
          that.$refs.packaging2.items_contenitori_alternativi.length > 0
        ) {
          // Cerco il contenitore associato a questa commessa e ne apro il dettaglio.
          that.caricamento_dati = false;
          that.$refs.packaging2.items_contenitori_alternativi.forEach(
            async (e) => {
              if (e.id_articolo_packaging == arg.id_articolo_packaging) {
                that.caricamento_dati = true;
                await that.$refs.packaging2.modificaContenitore(e);
                that.caricamento_dati = false;
              }
            }
          );
        } else {
          that.caricamento_dati = false;
          that.$refs.SnackbarQV.print(
            "orange",
            "Non sono stati trovati packaging per questo articolo."
          );
        }
      });
    },
    handleSchedaRichieste() {
      this.dialog_Richieste = true;
    },
    handleSelezionataMacchina(arg_id) {
      /* Filtro fra i work order in corso solo quelli associati alla macchina selezionata
       * e gli aggiungo un campo sel per lavorare con la checkbox nel dialog che aprirò */
      this.items_wo_multi = this.work_orders_in_corso.filter(
        (w) => w.id_macchina == arg_id
      );

      this.items_wo_multi.forEach((w) => (w.sel = false));

      // Chiudo il dialog di selezione della macchina per la multicommessa
      this.macchine_multi_visible = false;

      // Rendo visibile il dialog di selezione dei workorder per la multiregistrazione
      this.consuntivo_wo_multi_visible = true;
    },
    handleSelezionatiWO(arg_arr) {
      // Chiudo il dialog di selezione.
      this.consuntivo_wo_multi_visible = false;

      // Registro i WO che mi sono stati inviati
      this.items_wo_multi_reg_pezzi = new Array();
      arg_arr.forEach((w) => this.items_wo_multi_reg_pezzi.push(w));

      // Apro il dialog di registrazione multipla.
      this.key_registra_pezzi_multi =
        this.key_registra_pezzi_multi === 0 ? 1 : 0;
      this.registra_pezzi_multi_visible = true;
    },
    async handleUpdatePrelievi() {
      // Aggiorno i dati dei miei WO
      await this.getWorkOrdersUtente();

      // Ripesco dai dati aggiornati la versione aggiornata del mio WO selezionato.
      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio === this.work_order_sel.id_commessa_dettaglio
        ) {
          this.work_order_sel = JSON.parse(JSON.stringify(wo));
        }
      });
    },
    nascondiWorkOrder(item) {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "hideworkorder",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: item.id_commessa_dettaglio,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getWorkOrdersUtente();
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
          );
        }
        this.caricamento_dati = false;
      });
    },
    redirect() {
      this.$router.push("/home/production/controllo");
    },
    snackbarOpen() {
      // Funzione lanciata per segnalare allegati che non hanno la descrizione.
      this.$refs.SnackbarQV.print(
        "orange",
        "Aggiungere ad ogni Allegato dell'attività una descrizione."
      );
    },
    validaDisegno(arg) {
      // Chiudo il dialog di visualizzazione dei disegni.
      this.visualizza_disegno_visible = false;

      /* Metto a 1 la visione del disegno per tutti
       * gli oggetti che hanno questo id_ disegno. */
      this.work_orders_in_corso.forEach((elem) => {
        if (elem.id_disegno == arg.id_disegno) {
          elem.view_disegno = 1;
        }
      });
    },
    handleWorkOrderCompletato() {
      // Stampo un avviso e chiudo il dialog
      this.$refs.SnackbarQV.print("success", "Work Order Completato!");
      this.registra_pezzi_visible = !this.registra_pezzi_visible;

      // Aggiorno i dati della tabella.
      this.getWorkOrdersUtente();
    },
    handleWorkOrderAltCompletato() {
      // Stampo un avviso e chiudo il dialog
      this.$refs.SnackbarQV.print("success", "Work Order Completato!");
      this.registra_pezzi_alternativi_visible = !this
        .registra_pezzi_alternativi_visible;

      // Aggiorno i dati della tabella.
      this.getWorkOrdersUtente();
    },
    getArticolo(id_articolo) {
      return new Promise((resolve) => {
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticoli",
            token: localStorage.user_token,
            id_articolo: id_articolo,
          },
        };
        this.$store.dispatch("api", request).then((res) => {
          resolve(res.data.articolo[0]);
        });
      });
    },
    getArticoloPackaging(id_articolo) {
      return new Promise((resolve) => {
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticolipackaging",
            token: localStorage.getItem("user_token"),
            db_name: "quickproduction",
            id_utente: localStorage.id,
            id_articolo: id_articolo,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          resolve(res.data);
        });
      });
    },
    noConfermaEseguiCheck() {
      this.conferma_check_visible = false;

      if (this.stack_check[0]) {
        // Eseguo la funzione che sta attendendo nello stack.
        this.stack_check[0].funzione();

        // Elimino l'elemento che ho appena eseguito.
        this.stack_check.splice(1, 1);
      } else {
        console.log("entrato 3");
      }
    },
  },
  mounted() {
    document
      .getElementById("listener_Produzione2")
      .addEventListener("clicked_row", this.aggiungiWorkOrder);

    document
      .getElementById("listener_Produzione2")
      .addEventListener("clicked_row_start_it", this.aggiungiWorkOrderAndStart);

    /*this.$SSEController.addEventListener(
      "aggiornato_stato_commesse",
      this.getWorkOrdersUtente
    );*/

    /* Controllo se QuickLabel è abilitato, nel caso l'utente
     * usare la modifica del packaging dal carrello.*/
    this.getQuickLabelAllowed();
  },
  beforeDestroy() {
    if (document.getElementById("listener_Produzione2")) {
      document
        .getElementById("listener_Produzione2")
        .removeEventListener("clicked_row", this.aggiungiWorkOrder);

      document
        .getElementById("listener_Produzione2")
        .removeEventListener(
          "clicked_row_start_it",
          this.aggiungiWorkOrderAndStart
        );
    }

    /*this.$SSEController.removeEventListener(
      "aggiornato_stato_commesse",
      this.getWorkOrdersUtente
    );*/
  },
};
</script>
<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
</style>
